export const SET_SCROLL_HEIGHT = 'set_scroll_height' //设置滚动区域高度

export const GET_APPS     = 'get_apps'    //获取数据

export const SET_MENU     = 'set_menu'     //设置菜单

export const GET_MODULE   = 'get_module'   //得到模块

export const GET_IND      = 'get_ind'      //得到行业

export const DO_FLITER    = 'do_fliter'    //进行过滤

export const GO_PAGE      = 'go_page'      //加载新页面

export const PAGE_LOADING = 'page_loading' //开始加载

export const GET_APP      = 'get_app'      //得到信息

export const RESET_PARAMS = 'reset_params' //重置apps请求参数

export const RESET_HEIGHT = 'reset_height' //保存高度

export const SAVE_ORDER_FIELDS = 'save_order_fields' //保存订单form

export const GET_CUSTOMER_LIST = 'get_customer_list' //获取客户列表

export const SET_LOADING = 'set_loading' //全局加载

export const GET_LICENSE = 'get_license' //获取license

export const SET_SUCCESS = 'set_success' //提交意向成功

export const GO_NEXT_PAGE = 'go_next_page' //客户列表下一页

export const RESET_CUSTOMER_PARAMS = 'reset_customer_params' //重置客户列表参数

export const RESET_SCROLLTOP = 'reset_scrolltop' //重置应用列表滚动位置

export const CHOOSE_CUSTOMER = 'choose_customer' //选择客户











// WEBPACK FOOTER //
// ./project/constants/ActionTypes.js